import Model from '@/models/Model.js';
import moment from '@/plugins/vue-moment.js';
import QueryBuilder from '@/utilities/QueryBuilder.js';

export default class IdentityVerificationAttemptQuestions extends Model {
    static entity = 'identity-verification-attempt-questions';

    static answers = 'identity-verification-attempt-answers';

    static queryBuilder(endpoint) {
        return new QueryBuilder(endpoint);
    }

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            identity_verification_attempt_id: this.attr(null),
            identity_verification_question_id: this.attr(null),
            finalized_at: this.string(''),
            deleted_by: this.attr(null),
            deleted_at: this.string(''),
            question: this.attr(null),
            choices: this.attr(null),
            selected_choice: this.attr(null),
            verification_failed: this.attr(null),
            answer: this.attr(null),

            ...super.fields(),
        };
    }

    static async fetch(endpoint) {
        const { response } = await this.api().get(endpoint, {
            save: false,
        });

        return response.data;
    }

    static async submitAnswerForReview(attemptId) {
        const endpoint = this.queryBuilder(this.answers).toUrl();

        const model = this.query().where('identity_verification_attempt_id', attemptId).first();

        try {
            const { response } = await this.api().post(
                endpoint,
                {
                    user_id: model.user_id,
                    identity_verification_attempt_id: model.identity_verification_attempt_id,
                    identity_verification_question_id: model.identity_verification_question_id,
                    finalized_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                    user_answer: model.selected_choice,
                },
                { save: false }
            );

            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}
